/** Verwaltungs-/Admin-Hülle: Seitenleiste mit Gruppen (sc-nav) und Hauptbereich (sc-main). */
import { Marke } from "./Marke";
import type { ReactNode } from "react";
import { NavLink, Outlet } from "react-router";
import { Icon, type IconName } from "./Icon";
import { useAbmelden } from "../api/ich";

export interface NavGruppe {
  titel?: string;
  eintraege: { to: string; label: string; icon: IconName; end?: boolean; zaehler?: number }[];
}

export function Shell({ brand, kontext, gruppen, logoUrl, hinweis, children }: { brand: string; kontext?: string; gruppen: NavGruppe[]; logoUrl?: string | null; hinweis?: ReactNode; children?: ReactNode }) {
  const abmelden = useAbmelden();
  return (
    <div className="sc-app">
      <nav className="sc-nav" aria-label="Hauptnavigation">
        <div className="sc-nav__brand">
          {logoUrl ? <img src={logoUrl} alt="" className="app-logo" width={40} height={40} /> : <Marke size={40} />}
          <div className="sc-col" style={{ gap: 0 }}>
            <span className="sc-strong">{brand}</span>
            {kontext ? <span className="sc-muted sc-small">{kontext}</span> : null}
          </div>
        </div>
        {gruppen.map((g, i) => (
          <div key={i} style={{ display: "contents" }}>
            {g.titel ? <div className="sc-nav__group">{g.titel}</div> : null}
            {g.eintraege.map((e) => (
              <NavLink key={e.to} to={e.to} end={e.end} className={({ isActive }) => (isActive ? "is-on" : undefined)}>
                <Icon name={e.icon} size={20} />
                {e.label}
                {e.zaehler ? <span className="sc-nav__count">{e.zaehler}</span> : null}
              </NavLink>
            ))}
          </div>
        ))}
        <div className="sc-nav__foot">
          <a
            href="/anmelden"
            onClick={(ev) => {
              ev.preventDefault();
              void abmelden();
            }}
          >
            <Icon name="log-out" size={20} />
            Abmelden
          </a>
        </div>
      </nav>
      <main className="sc-main">
        {hinweis}
        {children ?? <Outlet />}
      </main>
    </div>
  );
}
